import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { css } from '@emotion/core';

import { productClick, pushRemarketingEvent } from '../lib/gaEnhancedEcommerce';
import A from '../Anchor/Anchor';
import { addToCart } from '../../../redux/modules/cart';
import { ga4SelectItem } from '../lib/ga4EnhancedEcommerce';
import { fkmxSelectItem } from '../lib/farmakomMetrics';
import { ImageDispatcher } from '../ImageDispatcher/ImageDispatcher';
import { isColorLight } from '../../../utils/colors';

import './ProductThumbnail.scss';

class SmallProductThumbnail extends Component {
  getPath = () => {
    const product = this.props.product;
    return `/${product.type}/${product.categorySeoName}/${
      product.subcategorySeoName ? product.subcategorySeoName : '_'
    }/${encodeURIComponent(product.seoName)}`;
  };

  goToProduct = event => {
    event.preventDefault();
    const product = this.props.product;

    const productGA = {
      id: product.code,
      name: product.name,
      category: product.categoryName,
      brand: product.brand,
    };

    if (this.props.advancedGa) {
      // GOOGLE ANALYTICS: PRODUCT CLICK
      // THEN ROUTER PUSH
      productClick(productGA, this.props.list);
    }

    // REMARKETING DINAMICO
    if (this.props.hasDynamicRemarketing) {
      pushRemarketingEvent('product', product);
    }

    // GA4 SELECT ITEM
    if (this.props.hasGoogleAnalytics4Advanced) {
      ga4SelectItem(product, this.props.ga4ListInfo);
    }

    // FKMX SELECT ITEM
    if (this.props.hasFarmakomMetrics) {
      fkmxSelectItem(product, this.props.ga4ListInfo);
    }

    this.props.router.push(this.getPath());
  };

  renderDiscount = (
    discount,
    price,
    listPrice,
    primaryColor,
    secondaryColor
  ) => {
    const discountStyle = css`
      & {
        font-size: 14px;
        font-weight: bold;
        position: absolute;
        top: 8px;
        right: 8px;
        display: flex;
        align-items: center;
        justify-content: center;
        background-color: ${secondaryColor};
        color: ${isColorLight(secondaryColor) ? '#333' : '#f9f9f9'};
        width: 48px;
        height: 48px;
        border-radius: 50%;
      }
    `;

    if (discount) {
      return (
        <div css={discountStyle}>{discount.toFixed(0).replace('.', ',')}%</div>
      );
    } else if (listPrice - price > 0) {
      const discountPercent = ((100 * (listPrice - price)) / listPrice)
        .toFixed(0)
        .replace('.', ',');
      return <div css={discountStyle}>{discountPercent}%</div>;
    }

    return null;
  };

  renderThumbnail = thumbnailStyle => {
    const { product, siteName, primaryColor, secondaryColor } = this.props;

    return (
      <div className={'product version-2'} css={thumbnailStyle}>
        <div className="visible-content">
          <A
            href={this.getPath()}
            onClick={this.goToProduct}
            style={{ color: '#4f4f4f' }}
          >
            <div className="product-content">
              <div className="product-image">
                <ImageDispatcher
                  src={product.image}
                  alt={product.imageAltText || `${product.name} - ${siteName}`}
                  style={{
                    objectFit: 'contain',
                    maxWidth: '100%',
                    height: '100%',
                    maxHeight: 240,
                  }}
                />
              </div>

              {!!product.name && (
                <div className="product-title">
                  {product.name.toLowerCase()}
                </div>
              )}

              {this.renderDiscount(
                product.discount,
                product.price,
                product.listPrice,
                primaryColor,
                secondaryColor
              )}
            </div>
          </A>
        </div>
      </div>
    );
  };

  render() {
    const { primaryColor, secondaryColor } = this.props;

    const thumbnailStyle = css`
      &.version-1 {
        .visible-content {
          min-height: unset !important;

          & a > .product-content > .text-container {
            padding: 16px;
            justify-content: flex-start;

            & .description {
              text-transform: capitalize;
              min-height: unset;
              margin-bottom: 4px;
            }

            & .discount {
              position: initial;
              display: flex;
              align-items: center;
              background-color: ${secondaryColor};
              color: #ffff;
              padding: 4px 8px;
              border-radius: 6px;
              width: 120px;
              font-size: 14px;
              font-weight: 700;
            }
            & .discount.reorder {
              background-color: #ed5a5a;
              position: absolute;
              right: -4%;

              font-size: 14px;
              width: 140px;
            }
            & .discount.advice {
              background-color: #222222;
              position: absolute;
              right: -4%;

              font-size: 14px;
              width: 172px;
            }
          }
          & a > .product-content > .product-image {
            height: 200px;
            img {
              padding-top: 25px;
              padding-bottom: 5px;
            }
          }
        }
      }

      &.version-2 {
        .visible-content {
          min-height: unset !important;

          background-color: #f8f8f8;
          border: 1px solid #d0d1d4;

          justify-content: flex-start;

          & a > .product-content > .product-image {
            background-color: #fff;
          }

          & a > .product-content > .text-container {
            padding: 16px;
            background-color: #f8f8f8;
            & .description {
              text-transform: uppercase;
            }
          }

          .discount {
            width: 100px;
            height: 28px;
            background-color: ${primaryColor};
            color: #ffff;
          }
        }
      }

      .product-title {
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 1;
        -webkit-box-orient: vertical;
        text-transform: capitalize;
        padding: 4px 16px;
        background-color: #e9e9e9;
        font-weight: 500;
        color: #333;
      }
    `;

    return <div>{this.renderThumbnail(thumbnailStyle)}</div>;
  }
}

function mapStateToProps(state, ownProps) {
  return {
    isMobile: state.layout.isMobile,
    siteName: state.store.data.datiFarmacia.siteName,
    sellProductsOutOfStock:
      state.store.data.funzionalita.sellProductsOutOfStock,
    advancedGa: state.store.data.features.advancedGa,
    hasDynamicRemarketing: state.store.data.features.hasDynamicRemarketing,
    primaryColor: state.store.data.loghiTemplate.brandColor,
    secondaryColor: state.store.data.loghiTemplate.secondaryColor,
    hasGoogleAnalytics4Advanced: !!state.store.data.features
      .hasGoogleAnalytics4Advanced,
    hasFarmakomMetrics: !!state.store.data.integrazioni.metrics.apiKey,
  };
}

SmallProductThumbnail = withRouter(SmallProductThumbnail);

export default connect(mapStateToProps, { addToCart })(SmallProductThumbnail);
